<!-- Este componente contiene:

// Datos de cabecera del nombre del titulo del curso y template
// Menu desplegable del contenido del curso 

-->

<template>
    <div>
        <v-layout justify-center align-center row class="header">
            <!--<v-flex xs1 sm1 px-1 py-1 class="iconos">
                <button @click="menu = !menu"><img class="menu-header" src="../assets/presentacion/menu.png" alt=""></button>
            </v-flex>-->
            <v-flex xs9 md10 sm10 class="header-titulo">
                <div class="header-titulo-btn">
                    <button @click="menu = !menu">
                        <div class="menu-header" >
                            <menu-app/>
                        </div>
                    </button>  
                </div>
                <div v-show="!$vuetify.breakpoint.xs">
                    <p><span class="tittle-big" v-html="titulo[0]"></span></p>
                </div>
            </v-flex>
            <v-spacer></v-spacer >
            <v-flex sm9 md6 lg6 xs12 text-sm-right class="titulo-pantalla">
                <p v-if="!$vuetify.breakpoint.xs" >
                    <span class="tittle-small subtema" v-html="'.'"></span>
                </p>
                <p class="pantallas subtemaName" v-html="$store.state.subTema"><span></span></p>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-left align-top class="menu-temporal animated fadeIn" v-if="menu || $store.state.menuAmpliar">
            <v-flex xs10 md4 py-1 class="menu-items animated fadeInLeft">
                <div class="cont-close pr-1" v-if="!$store.state.menuAmpliar">
                    <button @click="menu = !menu"
                        >
                        <v-icon class="close-icon" medium>close</v-icon>
                    </button>
                </div>
                <div class="cont-close pr-1" v-if="$store.state.menuAmpliar">
                    <button @click="$store.commit('menuStateAmpliar', false)"
                        >
                        <v-icon class="close-icon" medium>close</v-icon>
                    </button>
                </div>
                <!-- <div class="container-items">
                    <v-list class="cont-menu">
                    <template v-for="(menubot, indexUl) in data.menubots">
                        <template v-if="menubot.subt.length == 0">
                            <v-list-tile    class="menu-tile" v-if="conteoPags >= calculateNumberOfPages(0) + menubot.pages[0]"
                                            @click.native="clickNav, hideNav(indexUl), goTo(menubot.link)"
                                            :class="{'active':menubot.active}" :key="'tile'+indexUl"
                                >
                                {{menubot.name}}
                            </v-list-tile>
                        </template>
                        <template v-else>
                        <v-list-group   :value="menubot.active" class="menu-tile"
                                        v-if="conteoPags >= calculateNumberOfPages(0) + menubot.pages[0]"
                                        :key="'tile'+indexUl"
                                        :id="`modulo${indexUl+1}`"
                                        :class="{'noclick-menu': bloqueList[indexUl]}"
                            >
                            <v-list-tile    @click.native="clickNav, hideNav(indexUl), goTo(menubot.link)"
                                            class="tema" :class="{'active':menubot.active}"
                                            slot="activator"
                                        >
                                {{menubot.name}}
                            </v-list-tile>
                            <v-list-tile class="submenu-tile" @click="goTo(submenu.link), closemenu()"
                                        v-for="(submenu, index) in menubot.subt"
                                        :key="'subt'+indexUl+index"
                                        v-if="(submenu.pages[0] + calculateNumberOfPages(0)) <= conteoPags"
                                        :class="{'checkmenu':menubot.active}">
                                {{submenu.name}}
                            </v-list-tile>
                        </v-list-group>
                        </template>
                    </template>
                    </v-list>

                </div> -->
        
                <div class="container-items">
                    <v-list class="cont-menu">
                        <v-list-tile :class="{'active':menubot.active}" :key="'menubot'+indexUl"
                                 @click.native="clickNav, hideNav(indexUl), goTo(menubot.link)"
                                 class="menu-tile"
                                 v-for="(menubot, indexUl) in data.menubots" v-show="indexUl < 1">
                        {{menubot.name}}
                        </v-list-tile>
                        <v-list-group :key="'menubotb'+indexUl" :value="menubot.active" class="menu-tile"
                                  v-for="(menubot, indexUl) in data.menubots"
                                  v-show="conteoPags >= calculateNumberOfPages(indexUl) && indexUl >= 1">
                            <v-list-tile :class="{'active':menubot.active}"
                                        @click.native="clickNav, hideNav(indexUl), goTo(menubot.link)"
                                        class="tema" slot="activator">
                                {{menubot.name}}
                            </v-list-tile>
                            <v-list-tile :key="'subt'+indexUl+index" @click="goTo(submenu.link),hideNav(indexUl)"
                                        class="submenu-tile" v-for="(submenu, index) in menubot.subt"
                                        v-show="(submenu.pages[0] + calculateNumberOfPages(indexUl)) <= conteoPags">
                                {{submenu.name}}
                            </v-list-tile>
                    </v-list-group>
                    </v-list>

                </div>



            </v-flex>
            <!-- MODAL DE GLOSARIO -->
            <modal-glosario-app v-model="glosario" :fullscreen="true">
                <template slot="modaltittle"></template>
                <template slot="modalcontent"><Glosario/></template>
            </modal-glosario-app>

        </v-layout>
    </div>
</template>
<script>
import resourcesLoader from "../js/mixins/resources-loader";
import scormmixins from '../js/mixins/scormmixins'
import Glosario from '../components/Glosario'

export default {
    components: {
        Glosario,
        MenuApp: () => import('./svg/menu')
    },
    mixins: [resourcesLoader,scormmixins],
    data() {
        return {
            submenu: false,
            menu: false,
            glosario:false,
            data: '',
            cibergrafia: false,
            glosario: false,
            materialReferencia: false,
            atribuciones: false,
            materialReferencia: false,
            drawer: false,
            cibergrafiaData: [],
            referencias: [],
            listHeightScroll: false,
            titulo: '',
            bloqueList: Array(3).fill(true)
        }
    },
    created() {
        var self = this
        this.getJson('modulos/navegacion', data => {
            self.data = data
            self.calculateNumberOfPages()
        })
        this.getJson('textos_proyecto',function(data){
            self.titulo = data.nombre_del_proyecto
        })
        console.log('TITULO ' + this.titulo)
        this.desbloquear()
    },
    methods: {
        getData(data) {
            return data
        },
        openGlosario(){
            this.glosario = true
        },
        getModuleTitle() {
            return this.$store.state.title
        },
        adjustButtons() {
            var list = document.querySelector('.course-menu')
            var listContainer = document.getElementById('list-container')
            console.log('lch: '+listContainer.clientHeight + ' lh: '+list.offsetHeight)
            this.listHeightScroll= listContainer.clientHeight - 283 < list.offsetHeight;
        },
        hey(modNum) {
            var canTemas = 0
            for(var i = 0; i < modNum; i++) {
                canTemas += this.data.menubots[i].canTemas
            }
            return canTemas
        },
        desbloquear(){
            var routeArr = this.$route.path.split("/");
            var modName = routeArr[routeArr.length - 2];
            let modul = Number(modName.charAt(modName.length-1))
            for (let index = 0; index < modul; index++) {
                this.$set(this.bloqueList, index, false)
            }
        },
        clickNav() {
            var routeArr = this.$route.path.split("/");
            var modName = routeArr[routeArr.length - 2];
            var pageNum = routeArr[routeArr.length - 1];

            let modul = Number(modName.charAt(modName.length-1))
            this.desbloquear()

            this.data.menubots.forEach(function(element) {
                var botName = element.link.split("/");

                // Actualiza nombre en el encabezado
                if(pageNum >= element.pages[0] && pageNum <= element.pages[1]){
                    this.$store.commit('temaName', element.name)
                }
                // Muestra los temas que se han visitado y oculta los temas futuros
                if (element.link === this.$route.path) {
                } else if (modName === botName[0]) {
                    this.$store.commit('temaName', element.name)
                    element.active = true;
                } else {
                    element.active = false;
                }

                // Muestra los subtemas
                element.subt.forEach(function(subElem) {
                    var subLink = subElem.link.split("/")
                    if (subLink[1] === modName && (pageNum >= subElem.pages[0] && pageNum <= subElem.pages[1])) {
                        this.$store.commit('subTemaName', subElem.name)
                        this.$store.commit('temaName', element.name)
                        // this.$store.commit('temaName', subElem.name)
                        subElem.active = true;
                    } else {
                        subElem.active = false;
                    }
                    }, this)
            }, this);
        },
        hideNav(event) {
            if (this.data.menubots[event].subt.length === 0) {
                this.menu = false
            }
        },
        closemenu(){
            this.menu = false
        },
        calculateNumberOfPages(modNum) {
            return this.$store.getters.globalPage(modNum)
        },
        goTo(route){
            this.$router.push(route)
            console.log('route ' + route)
        },

    },
    computed: {
        // screenTrack() {
        //     return this.$store.state.screens;
        // },
        temaName() {
            return this.$store.state.tema;
        },
        subtemaName() {
            console.log('SUBTEMANAME '+this.$store.state.subTema)
            return this.$store.state.subTema;
        },
        showTrack() {
            var routeArr = this.$route.path.split("/");
            console.log('routerArr '+ routeArr)
            if (routeArr.length <= 2) {
                return false
            } else {
                return true
            }
        },
        currentPage() {
            return Math.floor(this.$route.params.unipage);
        }
    },
    watch: {
        '$route' (to, from) {
            this.clickNav();
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../sass/globals';
.noclick-menu{
    pointer-events: none;
    opacity: 0;
}
.menu-header{
    //height: 3rem;
    height: auto;
    width: 50px;
    margin: 0 10px 0 10px ;
    padding: 7px;
    display: -webkit-block;
}
.header{
    position: fixed;
    width: 100%;
    z-index: 2;
    background-color:#fafafa;// $color-inverted;
    color: $color-inverted;
    min-height: 64px;
    border-radius: 0px;
    //box-shadow: 0 0 2px black; 
    p {
        margin-left: 20px;
        margin: 0;
        padding: 0;
        //font-size: .73em;
    }
    .iconos{
        display: flex;
        justify-content: center;
    }
    .menu-icon{
        width: 64px;
        font-size: 3rem;
        color: $color-complement-one;
        &:hover{
            //color:$color-complement-two;
        }
    }
}
.close-icon{
    color: $color-primary;
    &:hover{
        //color:darken($color: $color-primary, $amount: 10);
    }
}
.container-items{
    .cont-menu{
        background:transparent;
    }
}
.modaltittle{
    width: 100%;
    background: $color-secondary;
}
.menu-temporal{
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0,0,0,0.3); 
    backdrop-filter: blur(3px);
    z-index: 4;
    .menu-items{
        background:$color-inverted;
        position: relative;
        p{
            font-size: 11pt;
        }
    }
}
.cont-close{
text-align: right;
}
.cont-submenu{
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    border-top: solid $color-primary 1px;
    padding: 5px 20px 4px 20px;
    width: 100%;
    color:$color-inverted;
    background: $color-complement-one;
    .icon{
        color: $color-inverted;
    &:hover{
        //color: $color-complement-two;
        cursor: pointer;
    }
        
    }
}

.btn-icon{
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
    flex-wrap: wrap;
    width: 20%;
    span{
        width: 100%;
        font-size: 0.8em;
    }
}

.menu-tile {
    font-family: 'fontBase-Bold';
    border-bottom: 3px solid $color-gray;
    margin-left: 15px;
    margin-right: 15px;
    padding:0px;
    cursor: pointer;
    transition: all 0.3s ease-out!important;
    color:$color-text;
    &:hover{
       // background: darken($color: $color-complement-one, $amount: 10);
    }
}
.submenu-tile {
  color:$color-text;
  font-family: 'fontBase-Regular';
  &:hover {
    //background-color: darken($color: $color-complement-one, $amount: 10);
  }
}

.tittle-big{
  font-size:1.4rem;
  text-align: left;
  line-height: 1.5rem;
  font-family: FontBase-Regular;
  color:#03738c;
}
.tittle-small{
  text-align: left;
  font-size:1.3rem;
  color: #a65682;
  font-family: FontBase-Italic;
}
.titulo-pantalla{
    padding-right: 140px;
    //display: none;
}
.pantallas,.subtemaName{
    color: $color-secondary;
    font-family: FontBase-Bold;
    text-align: end;
    padding-right: 10px;
    line-height: 1.5rem;
}

.tittle-small.subtema{
    opacity: 0;
}
@media (max-width: 420px) {
    .tittle-big{
        font-size:.9rem;
    }
    .tittle-small{
        text-align: left;
        font-size:.7rem;
        color: $color-text;
        font-family: FontBase-ExtraLight;
    }
    .menu-icon{
        width: 64px;
        font-size: 2rem;
        color: $color-complement-one;
    }
}
.header-titulo{
    display: flex;
    align-items: center;
    .header-titulo-btn .menu-header{
        margin-top: 5px;
        display: block;
        align-items: center;
    }
}
@media (max-width: 600px) {
    .titulo-pantalla{
        //display: block;
        padding-right: 80px;
    }
    .header-titulo p{
        display: none;
    }
}
.checkmenu{
    background: $color-gray;
}
@media (min-width: 560px){
    .iconos {
        -ms-flex-preferred-size: 6.666666666666664%;
        flex-basis: 6.666666666666664%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 6.666666666666664%; 
    }
}

@media (max-width: 559px){
    .iconos {
        -ms-flex-preferred-size: 15.666666666666664%;
        flex-basis: 15.666666666666664%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 15.666666666666664%; 
    }
}/*
@media (max-width: 990px){
    .iconos {
        -ms-flex-preferred-size: 7.666666666666664%;
        flex-basis: 7.666666666666664%;
        -webkit-box-flex: 0;
        -ms-flex-positive: 0;
        flex-grow: 0;
        max-width: 7.666666666666664%; 
    }
}*/
</style>

